import { render, staticRenderFns } from "./ThePriceModal.vue?vue&type=template&id=418a2ff6&scoped=true"
import script from "./ThePriceModal.vue?vue&type=script&lang=ts"
export * from "./ThePriceModal.vue?vue&type=script&lang=ts"
import style0 from "./ThePriceModal.vue?vue&type=style&index=0&id=418a2ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418a2ff6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSelectTheRange: require('/usr/src/nuxt-app/components/core/select/TheRange.vue').default})
